import { render } from "./Topic.vue?vue&type=template&id=b3fc34bc"
import script from "./Topic.vue?vue&type=script&lang=js"
export * from "./Topic.vue?vue&type=script&lang=js"
script.render = render

export default script